<template>
  <div>
    <Header :self="self" />
    <div class="container main">
      <div class="alert alert-danger" role="alert" v-if="error">
        {{error.message}}
      </div>

      <div class="text-center">
        <div class="mb-4">
          <a href="/connect/facebook"><button type="button" class="btn btn-lg btn-facebook"><i class="fab fa-facebook"></i> Sign in with Facebook</button></a>
        </div>
      </div>

      <form @submit.prevent="signIn" :disabled="submitting.signIn">
        <div class="form-group row" v-bind:class="{ 'form-group-error': $v.credentials.username.$error }">
          <label for="username" class="col-sm-2 col-form-label">Username</label>
          <div class="col-sm-10">
            <input type="text" class="form-control" id="username" placeholder="Username or Email Address" v-model="credentials.username" v-model.trim.lazy="$v.credentials.username.$model">
            <div class="error-input">Please provide your username or email address</div>
          </div>
        </div>
        <div class="form-group row" v-bind:class="{ 'form-group-error': $v.credentials.password.$error }">
          <label for="password" class="col-sm-2 col-form-label">Password</label>
          <div class="col-sm-10">
            <input type="password" class="form-control" id="password" v-model="credentials.password" v-model.trim.lazy="$v.credentials.password.$model">
            <div class="error-input">Please provide your password</div>
          </div>
        </div>
        <div class="form-group row">
          <label for="password" class="col-sm-2 col-form-label">&nbsp;</label>
          <div class="col-sm-10">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="long-term" value="true" v-model="credentials.longTerm">
              <label class="form-check-label" for="long-term">Keep me signed in</label>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button class="btn btn-primary" @click="signIn(credentials)" :disabled="submitting.signIn">Sign In</button>
        </div>
      </form>
      <div>
        <router-link to="/user/forgot-password">Forgot your password?</router-link>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  import { mapState, mapActions } from "vuex";
  import { required } from "vuelidate/lib/validators";

  export default {
    components: { Header, Footer },
    data() {
      return {
        credentials: {},
        error: null,
        submitting: { signIn: false, createCheckoutSession: false },
      };
    },
    head() {
      return {
        title: "Quozio - Sign In",
        meta: [
          { hid: "description", name: "description", content: "Sign in to access your Quozio account" }
        ],
        script: [
          {
            hid: "stripe",
            src: "https://js.stripe.com/v3/",
            defer: true,
            callback: () => { this.isStripeLoaded = true }
          }
        ]
      }
    },
    async asyncData({ store, app }) {
      await store.dispatch("self/get", app.$cookies);
    },
    methods: {
      async signIn() {
        this.error = null;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.submitting.signIn = true;
        this.$nuxt.$loading.start();
        let response = await this.signInAction({ credentials: this.credentials, cookies: this.$cookies });
        if (response.error) {
          // Only re-enable the submit button if an error.
          this.submitting.signIn = false;
          this.error = response.error;
          this.$nuxt.$loading.finish();
          return;
        }

        this.$nuxt.$loading.finish();

        // If the user signed in as part of the process to upgrade to Quozio Pro, redirect them to the checkout page.
        if (this.$route.query.then == "get-quozio-pro") {
          await this.checkout();
          return;
        }

        // If a redirect, it must start with a forward slash, no exceptions.
        // Otherwise, someone could hijack the join page and redirect the user to an external URL in an attempt to phish.
        let redirect = this.$route.query.redirect;
        if (redirect && redirect.substring(0, 1) != "/") {
          redirect = null;
        }

        if (redirect) {
          this.$router.push(redirect);
        } else {
          this.$router.push("/");
        }

      },
      async checkout() {

        this.$ga.event("GetQuozioPro", "Get Quozio Pro - Load Checkout", 0);

        this.submitting.createCheckoutSession = true;
        this.$nuxt.$loading.start();
        let response = await this.$dataService.post("/payments/create-checkout-session", { meta: { ref: this.$route.query.ref } });
        this.$nuxt.$loading.finish();
        if (response.error) {
          this.error = response.error;
          this.submitting.createCheckoutSession = false;
          return;
        }

        // Redirect to the checkout page.
        var stripe = Stripe(this.$config.STRIPE_PUBLIC_API_KEY);
        stripe.redirectToCheckout({ sessionId: response.data.id });

      },
      ...mapActions({ signInAction: "self/signIn" }),
    },
    computed: {
      ...mapState("self", { self: "self" }),
    },
    validations: {
      credentials: {
        username: {
          required
        },
        password: {
          required
        }
      }
    }
  };
</script>
